import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchBinDetail } from '../../actions/zones_actions';

import BinDetail from '../../components/Inventories/binDetail';

let binDetail = reduxForm({
    form: 'binDetail'
})(BinDetail);

function mapStateToProps(state) {
    return {
        currentBin: state.zones.currentBin,
        currentBinDetail: state.zones.currentBinDetail,
        detailIsLoading: state.zones.binDetailIsLoading,
        detailError: state.zones.binDetailError,
    }
}

export default connect(mapStateToProps, { fetchBinDetail })(binDetail)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/binDetail.jsx